/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdDrawerProps } from './type';

export const drawerDefaultProps: TdDrawerProps = {
  closeOnOverlayClick: true,
  destroyOnClose: false,
  overlayProps: {},
  placement: 'right',
  showOverlay: true,
  visible: false,
};
